import ReactDOM from 'react-dom/client';
import './styles/styles';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
// Not removing legacy dpendncies in case the import somehow contributes globally
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import $ from 'jquery';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { AuthKitProvider } from '@workos-inc/authkit-react';
import { AuthGuard } from './utils/AuthGuard';
import { getStatePathValue } from './utils/getStateValue';

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const pathToRedictTo = getStatePathValue(window.location.search);
const siteOrigin = window.location.origin;

// We set the redirect path to the local storage here
// Due to it being lost down the component tree otherwise
// There is a "Component rendering order" example in the JIRA task comments (PBI-343)
if (pathToRedictTo) {
  localStorage.setItem("workos_redirect_path", pathToRedictTo);
}

root.render(
  <AuthKitProvider
    clientId={process.env.REACT_APP_WORKOS_CLIENT_ID || ''}
    apiHostname={process.env.REACT_APP_WORKOS_API_DOMAIN || ''}
    redirectUri={siteOrigin + '/callback'}
  >
    <AuthGuard>
      <div>
        <App />
      </div>,
    </AuthGuard>
  </AuthKitProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
